import { StyledAllFarmsFarmCard } from './style';
import { QualityMarkData } from '../../types/ProductData';
import { useIntl } from 'react-intl';
import { FallbackImage } from '../UploadImage/fallBack/FallBackImage';

export interface props {
  name?: string;
  qmarks?: QualityMarkData[];
  registeredAddress?: string;
  imageUrl?: string;
  is_top_farm?: boolean;
  hoverable?: boolean;
}

export const AllFarmsFarmCard = ({
  name,
  qmarks,
  registeredAddress,
  imageUrl,
  is_top_farm,
  hoverable = true,
}: props) => {
  const intl = useIntl();

  const coverImg = (
    <FallbackImage
      src={imageUrl ? imageUrl : ''}
      type={'FarmCard'}
      preview={false}
    />
  );
  return (
    <StyledAllFarmsFarmCard cover={coverImg} hoverable={hoverable}>
      <div className={'overlay-wrapper'}>
        <div className={'overlay'}>
          {is_top_farm && (
            <div className={'top-farm'}>
              {intl.formatMessage({ id: 'all_farm_card.favorite' })}
            </div>
          )}
        </div>
      </div>
      <div className={'farms-card-content'}>
        <div className={'farms-card-title'}>{name}</div>
        <div className={'registered-address'}>{registeredAddress}</div>
        <div className={'qmarks-wrapper'}>
          <div className={'qmarks'}>
            {qmarks
              ?.slice(0, 8)
              .map((qmark, index) => (
                <FallbackImage
                  className="qmark-fm"
                  src={qmark.logo ? qmark.logo : ''}
                  type={'notFound'}
                  preview={false}
                  key={index}
                />
              ))}
          </div>
          <span className={'farms-card-inspect-button'}>
            {intl.formatMessage({ id: 'farm_card.view' })}
          </span>
        </div>
      </div>
    </StyledAllFarmsFarmCard>
  );
};
